import { Box, Button, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { downloadEmExportFileRequest } from 'redux/reducers/emExports/reducer';
import {
	getDownloadEmExportFileError,
	getDownloadEmExportFileLoader,
} from 'redux/reducers/emExports/selectors';

export const DownloadOrdersExport: FC = () => {
	const dispatch = useDispatch();
	const { hash } = useParams<{ hash: string }>();
	const downloadLoading = useSelector(getDownloadEmExportFileLoader);
	const downloadError = useSelector(getDownloadEmExportFileError);

	const handleDownload = () => {
		if (!hash) return;
		dispatch(downloadEmExportFileRequest({ hash }));
	};

	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', p: { xs: 2, sm: 4 } }}>
			<Card sx={{ width: { xs: '100%', sm: 600 }, maxWidth: '90vw' }}>
				<CardContent sx={{ p: { xs: 2, sm: 4 } }}>
					<Typography variant="h5" component="h1" color="primary" gutterBottom textAlign="center">
						Download Export File
					</Typography>

					<Typography variant="body1" color="text.secondary" textAlign="center">
						The export you have requested is ready. Click the button below to download the file.
					</Typography>

					{downloadError && (
						<Typography variant="body2" color="error" textAlign="center" sx={{ mt: 2 }}>
							{downloadError}
						</Typography>
					)}

					<Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
						<Button
							variant="contained"
							color="primary"
							onClick={handleDownload}
							disabled={!hash || downloadLoading}
						>
							{downloadLoading ? <CircularProgress size={24} color="inherit" /> : 'Download'}
						</Button>
					</Box>
				</CardContent>
			</Card>
		</Box>
	);
};
